import { useState, useEffect } from "react";
import logo from "../images/logo.png";
import patient2 from "../images/patient2.png";
import office2 from "../images/office2.png";

import "../css/ComponentStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser, setBaseUrl, setAuthToken } from "../redux/actions/userActions";
import { APIConstants, LoginConstants } from "../utilities/Constants";
import VerifyOtp from "./VerifyOtp";

const Login = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [practicId, setPracticeId] = useState("");
  const [loading, setLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const dispatch = useDispatch();

  const fetchNewToken = async (user) => {
  try {
    const inputJSON = { UserName: user.Username, PracticeId: user.practiceID };
    const url = `${APIConstants.SERVICES_URL}${LoginConstants.UpdatedToken}?sInputJSON=${JSON.stringify(inputJSON)}`;

    const res = await fetch(url);
    if (!res.ok) return;

    const parsedData = await res.json();
    dispatch(setAuthToken(parsedData.AuthToken));
    localStorage.setItem("sAuthToken", parsedData.AuthToken);
  } catch (err) {
    console.error("Token fetch error:", err);
  }
};


  const handleClick = async (e) => {
    e.preventDefault();

    localStorage.removeItem("activePage");

    const inputStruct = {
      PracticeID: practicId,
      Username: username,
      Password: password,
      RoleID: 7,
    };

    const myInput = JSON.stringify(inputStruct);
    console.log("Input of " + LoginConstants.GetLogin, myInput);

    const url = `${APIConstants.SERVICES_URL}${LoginConstants.GetLogin}?sInputJSON=${myInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);

          setErrorMessage("Authentication Failed. Please try again.");
        } else return response.json();
      })
      .then((data) => {
        const parsedLoginData = JSON.parse(data);
        console.log("ParsedLoginData", parsedLoginData);
        if (parsedLoginData) {
          setShowOtpModal(true);
        }

        setAuthenticated(true);
        dispatch(setUser(parsedLoginData));
        localStorage.setItem("userToken", "your_token_or_true");
fetchNewToken(parsedLoginData);
        if (parsedLoginData.sIsOTP == 0) {
          navigate("/locations");
        } else {
          setShowOtpModal(true);
        }
      })

      .catch((error) => {
        console.error(error);
        setErrorMessage("An error occurred. Please try again later.");
      });
  };

  useEffect(() => {
    document.title = "Login to Healthiva";
    localStorage.removeItem("activePage");
  }, [handleClick]);

  return (
    <>
      <div className="login_style" style={{ width: "150%" }}>
        {showOtpModal && (
          <VerifyOtp
            onVerifySuccess={() => navigate("/locations")} // navigate after OTP verification
            onClose={() => setShowOtpModal(false)}
          />
        )}

        <div className="">
          <div className="makeselection">
            <img src={logo} alt="logo" />

            <div className="text-center d-flex place-content-center">
              <img
                src={patient2}
                id="patimg"
                alt="logo"
                style={{ cursor: "pointer" }}
              />

              <img
                src={office2}
                id="offimg"
                alt="logo"
                style={{ cursor: "pointer", marginLeft: "150px" }}
              />
            </div>

            {/* office login modal */}

            <div id="office" className="col-lg-12 mt-5">
              <div className="modal-dialog" style={{ marginTop: "0px" }}>
                <div className="modal-content">
                  <div className="modal-body">
                    <form
                      className="form col-md-12 center-block"
                      onSubmit={handleClick}
                    >
                      <div className="form-group">
                        <input
                          type="text"
                          id="txtPhoneNumber"
                          className="form-control input-lg"
                          placeholder="Practice ID"
                          required
                          value={practicId}
                          onChange={(e) => setPracticeId(e.target.value)}
                        />
                      </div>
                      <div className="form-group mt-3">
                        <input
                          type="text"
                          className="form-control input-lg"
                          required
                          placeholder="Username"
                          id="txtOfcUserName"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                      </div>
                      <div className="form-group mt-3">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control input-lg"
                          required
                          placeholder="Password"
                          id="txtOfcPassword"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />

                        <FontAwesomeIcon
                          className="fa"
                          icon={showPassword ? faEye : faEyeSlash}
                          aria-hidden="true"
                          onClick={handleTogglePassword}
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="form-group input-lg mt-4">
                        <button
                          className="btn btn-primary btn-lg btn-block"
                          type="submit"
                          id="btnOfcLogin"
                          disabled={loading}
                        >
                          Sign In
                        </button>
                        <span className="d-flex">
                          <Link>Forgot your password?</Link>
                          {errorMessage && (
                            <div className="error-msg">{errorMessage}</div>
                          )}
                        </span>
                      </div>

                      {loading && (
                        <div className="overlay">
                          <div className="spinner-container">
                            <div
                              className="spinner-grow text-danger"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <div
                              className="spinner-grow text-warning"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <div
                              className="spinner-grow text-info"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      <div align="right">
                        {/* <asp:Label ID="lblerror"  Style="color: Red;"></asp:Label> */}
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <div className="col-md-12">
                      <label
                        id="lblOfcMessage"
                        style={{ color: "Red" }}
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
